import { StoreLocatorProps } from "../../../features/stores/components/StoreLocator"

export const toStoreLocatorProps = (item: any): StoreLocatorProps => ({
  title: item.data.labels?.title,
})
